import { RecordRTCPromisesHandler, StereoAudioRecorder } from 'recordrtc';

const recorderConfig = {
    type: 'audio',
    mimeType: 'audio/wav',
    recorderType: StereoAudioRecorder,
    desiredSampRate: 16000,
    numberOfAudioChannels: 1,
};

export const getStream = async () => {
    let stream = null;
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    }
    return stream;
};

export const getRecorder = stream => new RecordRTCPromisesHandler(stream.clone(), recorderConfig);

export const encodeWav = async blob => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
            const base64data = reader.result.replace('data:audio/wav;base64,', '');
            resolve(base64data);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
};
